import React from 'react';
import { Button } from './ui/Button';
import { ArrowLeft, ArrowRight } from 'lucide-react';

function Pagination({ currentPage, totalPages, onPageChange }) {
    if (totalPages <= 1) return null;

    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    // Gera uma lista de páginas para exibir (ex: 1, 2, 3, ..., 10)
    const getPageNumbers = () => {
        const maxPagesToShow = 5;
        const pages = [];
        
        let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
        let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

        if (endPage - startPage + 1 < maxPagesToShow) {
            startPage = Math.max(1, endPage - maxPagesToShow + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        
        // Adiciona reticências e a primeira/última página se necessário
        if (startPage > 1) {
            if (startPage > 2) pages.unshift('...');
            pages.unshift(1);
        }
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) pages.push('...');
            pages.push(totalPages);
        }

        // Remove duplicatas e garante a ordem
        return [...new Set(pages)];
    };

    const pageNumbers = getPageNumbers();

    return (
        <div className="flex justify-center items-center space-x-2 mt-8">
            <Button
                variant="outline"
                size="icon"
                onClick={handlePrevious}
                disabled={currentPage === 1}
            >
                <ArrowLeft className="h-4 w-4" />
            </Button>

            {pageNumbers.map((page, index) => (
                page === '...' ? (
                    <span key={index} className="px-2 text-muted-foreground">...</span>
                ) : (
                    <Button
                        key={index}
                        variant={page === currentPage ? 'default' : 'outline'}
                        onClick={() => onPageChange(page)}
                        className="w-10 h-10"
                    >
                        {page}
                    </Button>
                )
            ))}

            <Button
                variant="outline"
                size="icon"
                onClick={handleNext}
                disabled={currentPage === totalPages}
            >
                <ArrowRight className="h-4 w-4" />
            </Button>
        </div>
    );
}

export default Pagination;